import React, { useRef, useEffect } from 'react';
import IntlTelInput from "intl-tel-input/react";
import "intl-tel-input/styles";
import { PhoneNumberInputContainer } from './style';

const PhoneNumberInput = ({
  width,
  title,
  mainPage,
  additionalstyle,
  marginBottom,
  disabled,
  placeholder,
  onBlur,
  initialValue,
  onChangeNumber,
  setPhoneNumberValidity,
  error,
  errorMessage
}) => {

  const itiRef = useRef(null);

  useEffect(() => {
    if (itiRef.current && initialValue) {
      itiRef.current.getInstance().setNumber(initialValue);
    }
  }, [initialValue]);

  return (
    <PhoneNumberInputContainer
      mainPage={mainPage}
      additionalstyle={additionalstyle}
      error={error}
      disabled={disabled}
      width={width}
      marginBottom={marginBottom}
    >
      {title? <label>{title}</label>: null}
      <IntlTelInput
        ref={itiRef}
        initialValue={initialValue}
        initOptions={{ 
          initialCountry: 'ca',
          formatOnDisplay: true,
          nationalMode: true,
          autoPlaceholder: 'off',
          utilsScript: "https://cdn.jsdelivr.net/npm/intl-tel-input@23.0.10/build/js/utils.js"
        }}
        inputProps={{
          disabled: disabled,
          placeholder: placeholder,
          onBlur: onBlur,
        }}
        onChangeNumber={onChangeNumber}
        onChangeValidity={setPhoneNumberValidity}
      />
      {error? <div className="warning">{errorMessage? errorMessage:'Please enter a valid phone number'}</div>: null}
    </PhoneNumberInputContainer>
  )
}

export default PhoneNumberInput;
